<app-ship-details
  *ngIf="ship"
  [shipData]="ship"
  [shipResultArray]="shipResultArray"
  (newShipSelectedEmitter)="onShipChange($event)">
</app-ship-details>

<div
  class="card card-nc"
  *ngIf="shipLogsArray"
>
  <div class="card-heading">
    <i class="fa fa-history"></i>
    <span class="cardHeaderHeading"> Logs </span>
    <span class="pull-right panelHeaderHeading"
    >({{ shipLogsArray.length }} Logs)</span
    >
  </div>
  <table class="table table-striped table-bordered" *ngIf="shipLogsArray">
    <thead class="tableheading">
    <tr>
      <th class="text-center transactionHistHeader">DEVICE ID</th>
      <th class="text-center transactionHistHeader">LOG TYPE</th>
      <th class="text-center transactionHistHeader">DATE</th>
      <th class="text-center transactionHistHeader">VIEW/DOWNLOAD LOG</th>
    </tr>
    </thead>
    <tbody style="background-color: #ffffff;">
    <tr *ngIf="shipLogsArray.length == 0">
      <td align="center" colspan="7" style="height: 150px;">
        No logs found.
      </td>
    </tr>
    <tr *ngFor="let sl of shipLogsArray">
      <td
        class="text-center transactionHistText"
      >
        {{ sl.deviceId }}
      </td>
      <td class="text-center transactionHistText">
        {{ sl.logType }}
      </td>
      <td class="text-center transactionHistText">
        {{ sl.dateCreated }}
      </td>
      <td class="text-center transactionHistText">
        <button *ngIf="hasEntitlement('TAB_SHIP_LOGS')" id='{{sl.uuid}}'
          class="button" (click)="goToLogDetails(sl)">download</button>
      </td>
    </tr>
    </tbody>
  </table>
</div>
